import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {logoutAction} from '../rootAction';
import {RelationalGroupFieldType} from '../../components/pages/search-term-report/modal/RelationalGroupFieldsSelectionDialog';

interface STRState {
  currentFieldTemplateId: number | undefined;
  currentStrReportId: string | undefined;
  relationalGroupFields: RelationalGroupFieldType[];
}

const initialState: STRState = {
  currentFieldTemplateId: undefined,
  currentStrReportId: undefined,
  relationalGroupFields: [],
};

const strSlice = createSlice({
  name: 'STR',
  initialState,
  reducers: {
    setCurrentFieldTemplateId: (
      state,
      action: PayloadAction<number | undefined>
    ) => {
      state.currentFieldTemplateId = action.payload;
    },
    setStrReportId: (state, action: PayloadAction<string | undefined>) => {
      state.currentStrReportId = action.payload;
    },
    setRelationalGroupFields: (
      state,
      action: PayloadAction<RelationalGroupFieldType[]>
    ) => {
      state.relationalGroupFields = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => {
      return initialState;
    });
  },
});

export const {
  setCurrentFieldTemplateId,
  setStrReportId,
  setRelationalGroupFields,
} = strSlice.actions;
export default strSlice.reducer;
